"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SVBApiDetailsTableofDetails = props => {
  var _props$data, _Object$keys, _data$columns, _data$rows;
  const data = (_props$data = props === null || props === void 0 ? void 0 : props.data) !== null && _props$data !== void 0 ? _props$data : [];
  return ((_Object$keys = Object.keys(data)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0 && /*#__PURE__*/_react.default.createElement("table", {
    className: "table caption-top"
  }, /*#__PURE__*/_react.default.createElement("thead", {
    className: "svb-table-of-details-thead"
  }, /*#__PURE__*/_react.default.createElement("tr", null, data === null || data === void 0 || (_data$columns = data.columns) === null || _data$columns === void 0 ? void 0 : _data$columns.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("th", {
      key: index,
      className: "align-middle product-font-color-white sub-heading th-sm ".concat(index === 1 ? 'w-50' : 'w-25'),
      scope: "col"
    }, item);
  }))), /*#__PURE__*/_react.default.createElement("tbody", null, data === null || data === void 0 || (_data$rows = data.rows) === null || _data$rows === void 0 ? void 0 : _data$rows.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: index,
      className: "align-middle svb-table-of-details-trow"
    }, item === null || item === void 0 ? void 0 : item.map((i, ind) => {
      return /*#__PURE__*/_react.default.createElement("td", {
        key: ind,
        className: "paragraph"
      }, i);
    }));
  })));
};
var _default = SVBApiDetailsTableofDetails;
exports.default = _default;